import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  followRadioLink(event) {
    event.stopPropagation();
    event.preventDefault();
    // A filter link only changes the query; keep the live path so the active tab
    // (kept current by persistent-tabs' pushState) is preserved.
    const target = new URL(event.currentTarget.href);
    target.pathname = window.location.pathname;
    window.location.href = target.toString();
  }
}
